/* @author: Augusto Monteiro */

Greenmile.Panel = Greenmile.Panel || {};

Greenmile.Panel.Resources = {

    defaultProjections: {
        getPanel: { "filters": ["*", "panelCardFields.*", "panelCardFields.field.*", "panelRules.*", "panelRules.panelRuleConditions.*"] }
    },

    defaultError: function (errorCallback) {

        return function (xhr) {
            if (errorCallback) {
                errorCallback();
            }
            Monet.Configurations.errorNotification(null, xhr);
        };

    },

    criteriaById: function (id) {
        return {
            "criteriaChain": [
                { "and": [{ "attr": "id", "eq": id }] }
            ]
        };
    },

    doRequest: function (args) {

        var ajax = new Monet.Ajax();
        ajax.url = args.url;
        ajax.method = args.method;
        ajax.data = args.data;

        ajax.error = () => {
            this.defaultError(args.onError)
        };
        ajax.success = (response) => {
            args.onSuccess(response);
        }

        ajax.send();

    },

    getPanelById: function (args) {
        var projection = args.projection || this.defaultProjections.getPanel;

        args.url = "Panel/restrictions?criteria=" + JSON.stringify(projection);
        args.method = "POST";
        args.data = this.criteriaById(args.id);

        this.doRequest(args);
    },

    getCardsByMonetCriteria: function (args) {
        args.url = "Panel/" + args.id + "/ViewCards";
        args.method = "POST";

        this.doRequest(args);
    }
};
